<template>
  <section class="schedule-header level">
    <div class="header-top level-left">
      <h1 class="title">FLIGHT SCHEDULE</h1>
    </div>

    <div class="status-cards-wrapper level-right">
      <div
        v-for="(stat, index) in cards"
        :key="index"
        class="status-card"
        :class="stat.type"
      >
        <p class="stat-label stat-text">{{ stat.label }}</p>
        <p class="stat-value stat-text">{{ stat.value }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ScheduleHeader",
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },

  computed: {
    cards() {
      return [
        {
          label: "Total Flights",
          value: this.stats.TotalFlights,
          type: "status-total",
        },
        {
          label: "Completed",
          value: this.stats.Completed,
          type: "status-completed",
        },
        {
          label: "In Progress",
          value: this.stats.InProgress,
          type: "status-progress",
        },
        {
          label: "Overdue",
          value: this.stats.Overdue,
          type: "status-overdue",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-header {
  display: flex;
  align-items: center;
  margin: 24px 0 16px 0;

  .header-top {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .status-cards-wrapper {
    gap: 16px;

    .status-card {
      min-width: 200px;
      padding: 8px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #ddd;
      border-radius: 8px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      transition: all 0.2s ease;

      &:hover {
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
      }

      .stat-label {
        font-size: 16px;
        color: #666;
        letter-spacing: 0.8px;
      }

      .stat-value {
        font-size: 20px;
      }

      .stat-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 1160px) {
  .schedule-header {
    flex-direction: column;
    align-items: flex-start;
    margin: 24px 0 16px 0;

    .header-top {
      width: 100%;
      margin-bottom: 12px;
    }

    .status-cards-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-start;
      margin: 0;

      .status-card {
        flex: 1 1 auto;
        min-width: 160px;

        .stat-label {
          font-size: 14px;
        }

        .stat-value {
          font-size: 18px;
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .schedule-header {
    margin: 16px 0 12px 0;

    .header-top {
      .title {
        font-size: 24px;
      }
    }

    .status-cards-wrapper {
      gap: 12px;

      .status-card {
        flex: 1 1 calc(50% - 6px);
        max-width: calc(50% - 6px);
        min-width: 150px;
        padding: 7px 9px;

        .stat-label {
          font-size: 13px;
          letter-spacing: 0.6px;
        }

        .stat-value {
          font-size: 17px;
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .schedule-header {
    margin: 12px 0 8px 0;

    .status-cards-wrapper {
      gap: 8px;

      .status-card {
        flex: 1 1 calc(50% - 4px);
        max-width: calc(50% - 4px);
        min-width: 140px;
        padding: 6px 8px;

        .stat-label {
          font-size: 12px;
          letter-spacing: 0.5px;
        }

        .stat-value {
          font-size: 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .schedule-header {
    margin: 12px 0 8px 0;

    .header-top {
      margin-bottom: 8px;

      .title {
        font-size: 20px;
      }
    }

    .status-cards-wrapper {
      gap: 8px;

      .status-card {
        flex: 1 1 100%;
        max-width: 100%;
        min-width: unset;
        padding: 8px 10px;

        .stat-label {
          font-size: 12px;
          letter-spacing: 0.5px;
        }

        .stat-value {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
